/// <amd-module name="Analytics/Boards/VelocityQueries/AggregationWorkItemTypeFieldsQuery" />
import { WorkItemTypeField } from "Analytics/Boards/BoardsQueries/DataContracts";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { VelocityQueryBase } from "./VelocityQueryBase";

// Analogous to Tfs/Service/WebAccess/Widgets/Scripts/DataServices/ConfigurationQueries/AggregationWorkItemTypeFieldsQuery.ts
export class AggregationWorkItemTypeFieldsQuery extends VelocityQueryBase<WorkItemTypeField[]> {
    private static generateQueryOptions(projectId: string): ODataQueryOptions {
        const $filter = "(FieldType eq 'Integer' or FieldType eq 'Double') and (not startswith(FieldReferenceName,'System.'))";

        return {
            entityType: "WorkItemTypeFields",
            oDataVersion: latestODataVersion,
            project: projectId,
            $filter: $filter
        };
    }
    private queryName?: string;

    constructor(command: string, projectId: string, queryName?: string) {
        super(command, AggregationWorkItemTypeFieldsQuery.generateQueryOptions(projectId));
        this.queryName = queryName;
    }

    public getQueryName(): string {
        return this.queryName || "AggregationWorkItemTypeFieldsQuery";
    }
}
